module.exports = __webpack_public_path__ + "static/img/printer.5c831e8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/me-lesson/printer.gif
// module id = I9E+
// module chunks = 1